import React from 'react';
import Button from 'react-bootstrap/Button';
import './StorageExplorerStyle.css';

/** The ways to look at the lab's storage, in the order they are offered. */
export const STORAGE_VIEWS = [
  { value: 'map', label: 'Map' },
  { value: 'list', label: 'List' },
  { value: 'columns', label: 'Columns' },
];

/** The view that opens when the URL asks for nothing. */
export const DEFAULT_STORAGE_VIEW = 'map';

/**
 * The view a `?view=` value means. Anything unknown is the map.
 *
 * @param {string|null|undefined} value
 * @returns {'map'|'list'|'columns'}
 */
export function resolveStorageView(value) {
  return STORAGE_VIEWS.some(view => view.value === value) ? value : DEFAULT_STORAGE_VIEW;
}

/**
 * Switch between the storage map, the list, and the columns. All three show the
 * same places and do the same things: the map is the lab's layout, the list is
 * the whole tree in one column, and the columns run room to box left to right.
 *
 * @param {Object} props
 * @param {'map'|'list'|'columns'} [props.view]
 * @param {Function} [props.onChange] - ('map'|'list'|'columns') => void
 */
const StorageViewToggle = ({ view = DEFAULT_STORAGE_VIEW, onChange }) => (
  <div className="storage-view-toggle" role="group" aria-label="Storage view">
    {STORAGE_VIEWS.map(option => (
      <Button
        key={option.value}
        type="button"
        aria-pressed={view === option.value}
        onClick={() => onChange?.(option.value)}
      >
        {option.label}
      </Button>
    ))}
  </div>
);

export default StorageViewToggle;
